import { createContext } from 'react'

// eslint-disable-next-line no-unused-vars
import { ITabsContext } from '../interfaces/tabs'

export const TabsContext = createContext<ITabsContext>({} as ITabsContext)
